export function showBlockingOverlay(message = 'Signing you out…') {
  try {
    const appRoot =
      document.getElementById('app-root') || document.getElementById('root');
    if (appRoot) appRoot.setAttribute('inert', '');

    document.body.style.overflow = 'hidden';

    const keyBlocker = e => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };
    window.addEventListener('keydown', keyBlocker, { capture: true });

    // Full-screen overlay that captures all pointer events
    const overlay = document.createElement('div');
    overlay.id = 'app-logout-overlay';
    Object.assign(overlay.style, {
      position: 'fixed',
      inset: '0',
      zIndex: '999999',
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'progress',
      userSelect: 'none',
    });
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', message);

    // Swallow all clicks
    [
      'click',
      'mousedown',
      'mouseup',
      'pointerdown',
      'pointerup',
      'touchstart',
      'touchend',
    ].forEach(evt =>
      overlay.addEventListener(
        evt,
        e => {
          e.preventDefault();
          e.stopPropagation();
        },
        { capture: true },
      ),
    );

    document.body.appendChild(overlay);

    // Return a no-op cleanup; we’ll navigate away, so the page unloads anyway.
    return () => {
      window.removeEventListener('keydown', keyBlocker, { capture: true });
      if (appRoot) appRoot.removeAttribute('inert');
      document.body.style.overflow = '';
      overlay.remove();
    };
  } catch {
    // ignore—best effort
    return () => {};
  }
}
